import AbstractTrack from 'common/services/doxy-analytics/abstract.track';
import { RootScopeEvents } from 'common/services/root-scope-types';
import { createLogger } from 'utility/datadog-util';
export default class ClosedCaptionsTrack extends AbstractTrack {
    /* @ngInject */
    constructor($injector) {
        super($injector);
        this.$injector = $injector;
        const institution = this.stateWatcher.getInstitutionInfo();
        const userInfo = this.stateWatcher.getUserInfo();
        const context = {
            anonymous_id: userInfo.userId,
            clinic_domain: institution.domain,
            clinic_id: institution.clinicId,
            plan_type: userInfo.planType,
            user_id: userInfo.userId,
            user_type: userInfo.userType,
        };
        // Create a logger for this track with the
        this.logger = createLogger('closedCaptions', { context });
    }
    start() {
        this.$rootScope.$on(RootScopeEvents.CLOSED_CAPTIONS.STOPPED, () => {
            this.logger?.info('[Closed Captions]: Live captions stopped successfully');
        });
        this.$rootScope.$on(RootScopeEvents.CLOSED_CAPTIONS.ERROR_STOPPING, () => {
            this.logger?.error('[Closed Captions]: Error stopping live captions');
        });
        this.$rootScope.$on(RootScopeEvents.CLOSED_CAPTIONS.DOCTOR_TOGGLED, ($e, enabled) => {
            this.logger?.info('[Closed Captions]: Doctor toggled live captions', {
                enabled,
            });
        });
        this.$rootScope.$on(RootScopeEvents.CLOSED_CAPTIONS.FAIL_START_VIA_REALTIME_SIGNALING, ($e, error) => {
            this.logger?.error('[Closed Captions]: Failed to start live captions via realtime signaling:', error);
        });
        this.$rootScope.$on(RootScopeEvents.CLOSED_CAPTIONS.FAIL_SELF_CAPTION_CREATION, ($e, error) => {
            this.logger?.error('[Closed Captions]: Failed to create self-caption subscriber:', error);
        });
        this.$rootScope.$on(RootScopeEvents.CLOSED_CAPTIONS.FAIL_SELF_CAPTION_SUBSCRIPTION, ($e, error) => {
            this.logger?.error('[Closed Captions]: Error enabling self-caption subscription:', error);
        });
        this.$rootScope.$on(RootScopeEvents.CLOSED_CAPTIONS.SELF_CAPTION_DESTROYED, () => {
            this.logger?.info('[Closed Captions]: Self-caption destroyed');
        });
        this.$rootScope.$on(RootScopeEvents.CLOSED_CAPTIONS.FAIL_TO_SUBSCRIBE, ($e, error) => {
            this.logger?.error('[Closed Captions]: Failed to subscribe to captions:', error);
        });
    }
}
